import { BaseViewStore } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import moment from 'moment';
import { translate } from 'core/utils';
import _ from 'lodash';

class BaasicTableExportViewStore extends BaseViewStore {
	@observable visible = false;
	@observable disableExport = false;
	tableViewStore = null;

	options = {
		fieldSeparator: ',',
		quoteStrings: '"',
		decimalSeparator: '.',
		showLabels: true,
		showTitle: true,
		title: '',
		useTextFile: false,
		useBom: true,
		useKeysAsHeaders: true,
	};

	constructor(rootStore, { tableViewStore, fileTitle }) {
		super(rootStore);
		makeObservable(this);
		this.options.title = fileTitle;
		this.tableViewStore = tableViewStore;
		this.dateFormat = moment.localeData().longDateFormat('L');
	}

	@action.bound
	setVisibility = visible => {
		if (this.visible) {
			this.visible = visible;
		}
	};

	@action.bound
	toggleVisibility = () => {
		this.visible = !this.visible;
	};

	@action.bound
	constructKeyList = () => {
		let exportToCsvFilterList = [];
		_.forEach(this.tableViewStore.tableData.columns, column => {
			if (column.selected && !column.ignoreOnExport) {
				exportToCsvFilterList.push({
					headerName: translate(column.title),
					keyName: column.key,
				});
			}
		});
		return exportToCsvFilterList;
	};

	@action.bound
	exportData = async (exportAllPages = false) => {
		const totalRecords = this.tableViewStore.listStore.response.totalRecords;
		if (totalRecords > 0) {
			let defaultFilter = { ...this.tableViewStore.queryUtility.filter };
			if (exportAllPages) {
				defaultFilter.rpp = totalRecords;
				defaultFilter.pageSize = totalRecords;
				defaultFilter.pageNumber = 1;
			}
			defaultFilter.fileName = `${this.options.title.replace(' ', '')}_${moment().format('LLL')}`;
			defaultFilter.keys = this.constructKeyList(defaultFilter);
			defaultFilter.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			defaultFilter.dateFormat = this.dateFormat.toLowerCase().replaceAll('m', 'M');
			const csvFile = await this.tableViewStore.listStore.exportToCsv(defaultFilter);
			const fileName = csvFile.headers['content-disposition'].split('filename=')[1];
			const blobData = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvFile.data], {
				type: 'text/csv;charset=utf-8;',
			});
			saveAs(blobData, fileName.substring(1, fileName.length - 1));
			this.disableExport = false;
		} else {
			this.rootStore.notificationStore.error(['EXPORTCSV.NOTHINGTOEXPORT']);
		}
	};
}

export default BaasicTableExportViewStore;



// WEBPACK FOOTER //
// ./src/common/stores/BaasicTableExportViewStore.js